import { DateTime } from 'luxon';

export function validateRangeStartDate(value: string | undefined) {
  if (!value) return true;
  const dt = DateTime.fromISO(value);
  if (!dt.isValid) return 'Range Start must be a valid date';
  if (dt.startOf('day') < DateTime.now().startOf('day')) {
    return 'Range Start must not be in the past';
  }
  return true;
}

export function validateRangeEndDate(value: string | undefined) {
  if (!value) return true;
  const dt = DateTime.fromISO(value);
  if (!dt.isValid) return 'Range End must be a valid date';
  if (dt.startOf('day') < DateTime.now().startOf('day')) {
    return 'Range End must not be in the past';
  }
  return true;
}
